import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Link } from 'react-router-dom';
import { getRootUrl } from 'helpers/url';
import DisplayAssignment from './DisplayAssignment';
import { Haldor__Block, addBlockTranslations } from '@haldor/ui';
import SelectAssignment from './SelectAssignment';
import CreateAssignment from './CreateAssignment';
import './_AssignmentBlock.scss';

var AssignmentBlock = /*#__PURE__*/function (_Haldor__Block) {
  _inherits(AssignmentBlock, _Haldor__Block);

  var _super = _createSuper(AssignmentBlock);

  function AssignmentBlock(_props) {
    var _this;

    _classCallCheck(this, AssignmentBlock);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "onAssignmentSelect", function (assignment) {
      var foundInResources = _this.getResources().findIndex(function (resource) {
        return resource.id == assignment.id;
      });

      if (foundInResources < 0) {
        var isHaldorAssignment = assignment.id == parseInt(assignment.id, 10);

        if (isHaldorAssignment) {
          _this.addResource('haldor.assignment.block.assignment', _objectSpread(_objectSpread({}, assignment), {}, {
            existing: true
          }));
        } else {
          _this.addResource('haldor.assignment.block.teamsassignment', _objectSpread(_objectSpread({}, assignment), {}, {
            existing: true
          }));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAssignmentCreated", function (assignments) {
      if (assignments != null) {
        assignments.forEach(function (assignment) {
          _this.addResource('haldor.assignment.block.assignment', assignment);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "consume", function (props) {
      return /*#__PURE__*/React.createElement("div", {
        className: "block--assignment-block consume"
      }, props.resources != null && props.resources.length > 0 ? props.resources.map(function (resource) {
        var assignmentId = resource.origin != null && resource.origin.toUpperCase() == 'TEAMS' ? resource.externalID : resource.id;
        return /*#__PURE__*/React.createElement(Link, {
          className: "assignment-resource",
          to: "".concat(getRootUrl(), "assignment/").concat(assignmentId),
          key: assignmentId
        }, /*#__PURE__*/React.createElement(DisplayAssignment, {
          assignment: resource
        }));
      }) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "edit", function (props) {
      var editor = _this.api.getEditor();

      var planningAssessments = null;

      if (editor.getProp('planningAssessments') != null) {
        planningAssessments = JSON.parse(JSON.stringify(editor.getProp('planningAssessments')));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "block--assignment-block"
      }, props.resources != null && props.resources.length > 0 ? props.resources.map(function (resource) {
        return /*#__PURE__*/React.createElement("div", {
          className: "assignment-resource",
          key: resource.id
        }, /*#__PURE__*/React.createElement(DisplayAssignment, {
          remove: function remove() {
            return _this.removeResource(resource);
          },
          assignment: resource
        }));
      }) : null, /*#__PURE__*/React.createElement(SelectAssignment, {
        onPicked: _this.onAssignmentSelect
      }), /*#__PURE__*/React.createElement(CreateAssignment, {
        planningAssessments: planningAssessments,
        onCreated: _this.onAssignmentCreated
      }));
    });

    _this.name = 'Haldor.Blocks.Assignment';
    _this.order = 47;

    _this.icon = function () {
      return /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w2.org/2000/svg",
        viewBox: "0 0 50 50",
        dangerouslySetInnerHTML: {
          __html: "\n\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t\t<style>.icon-block-assignment-1{fill:#c8c9c8;}</style>\n\t\t\t\t\t\t</defs>\n\t\t\t\t\t\t<path class=\"icon-block-assignment-1\" d=\"M36.85,7.23H13.15a5.92,5.92,0,0,0-5.92,5.92v23.7a5.92,5.92,0,0,0,5.92,5.92h23.7a5.92,5.92,0,0,0,5.92-5.92V13.15A5.92,5.92,0,0,0,36.85,7.23ZM13.19,38.78a2,2,0,0,1-2-2l0-3.1V13.15a2,2,0,0,1,2-2h23.7a2,2,0,0,1,2,2V34.87l0,1.94a2,2,0,0,1-2,2l-22.63,0Z\"/>\n\t\t\t\t\t\t<path class=\"icon-block-assignment-1\" d=\"M22.78,33.31a2,2,0,0,1-1.44-.63L14.8,25.46a2,2,0,0,1,2.88-2.71l5.08,5.68,9.46-11a2,2,0,0,1,2.78-.3,2,2,0,0,1,.3,2.77l-.15.18L24.24,32.66a2,2,0,0,1-1.44.65Z\"/>\n\t\t\t\t\t"
        }
      });
    };

    addBlockTranslations('sv-se', [{
      output: 'Uppgifter',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('en-us', [{
      output: 'Assignments',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('nb-no', [{
      output: 'Oppgaver',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('da-dk', [{
      output: 'Opgaver',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('uk', [{
      output: 'Задачі',
      id: 'Haldor.Blocks.Assignment'
    }]);

    _this.registerResourceType('haldor.assignment.block.assignment', {
      id: 'number',
      title: 'string',
      assignmentType: 'string?',
      description: 'string?',
      dueDate: 'string',
      groupEnabled: 'boolean',
      publishedAssessments: 'number',
      sectionId: 'string',
      startDate: 'string',
      status: 'string',
      submittedTasks: 'number',
      totalTasks: 'number'
    });

    _this.registerResourceType('haldor.assignment.block.teamsassignment', {
      id: 'string',
      displayName: 'string',
      dueDateTime: 'string',
      status: 'string',
      classId: 'string',
      allowLateSubmissions: 'boolean'
    });

    return _this;
  }

  return _createClass(AssignmentBlock);
}(Haldor__Block);

export default AssignmentBlock;